import { recentQuotesStyles } from "@insite/content-library/Widgets/Common/RecentQuotes";
import getColor from "@insite/mobius/utilities/getColor";

import { css } from "styled-components";

Object.assign(recentQuotesStyles, {
    cardList: {
        gridContainer: {
            css: css`
                border: 1px solid ${getColor("common.border")};
                margin-bottom: 20px;
            `,
        },
    },
    noQuotesGridItem: {
        width: 12,
        css: css`
            justify-content: center;
        `,
    },
});
